var keys = Object.keys, getOwnPropertySymbols = Object.getOwnPropertySymbols;
export var getKeysAndSymbols = function (obj) {
    var result = keys(obj);
    if (getOwnPropertySymbols !== undefined) {
        result = result.concat(getOwnPropertySymbols(obj));
    }
    return result;
};
export default getKeysAndSymbols;

//# sourceMappingURL=getKeysAndSymbols.js.map



//////////////////
// WEBPACK FOOTER
// ./~/reassemble/lib/utils/getKeysAndSymbols.js
// module id = 10
// module chunks = 0